import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { EXPERTISE } from '@/data/mockData';
import { SectionTitle, FadeIn } from '@/components/common/SectionTitle';
import { HOME } from '@/constants/testIds';

const Expertise = () => {
  const testIds = {
    selenium: HOME.expertiseSelenium,
    playwright: HOME.expertisePlaywright,
    appium: HOME.expertiseAppium,
  };
  return (
    <section className="relative py-24 sm:py-32 bg-[#050A14]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle
          label="Our Expertise"
          title={<span className="font-semibold">Three career-defining automation stacks. One AI-first philosophy.</span>}
          subtitle="Every program ships with curriculum, real-time industry projects, AI integrations, and lifetime mentorship."
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {EXPERTISE.map((card, i) => (
            <FadeIn key={card.id} delay={i * 0.12}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ duration: 0.3 }}
                data-testid={testIds[card.id]}
                className="relative h-full glass rounded-2xl p-7 overflow-hidden group hover:border-brand-cyan/40 transition-colors"
              >
                <div className={`absolute -top-24 -right-24 w-64 h-64 rounded-full bg-gradient-to-br ${card.accent} blur-3xl opacity-60 group-hover:opacity-100 transition`} />
                <div className="relative">
                  <div className="text-xs tracking-[0.3em] uppercase text-brand-cyan/80 font-mono">Stack 0{i + 1}</div>
                  <h3 className="mt-4 font-display text-xl sm:text-2xl font-bold leading-tight">{card.title}</h3>
                  <p className="mt-3 text-sm text-white/70 leading-relaxed">{card.short}</p>

                  <div className="mt-5 flex flex-wrap gap-1.5">
                    {card.tools.map((t) => (
                      <span key={t} className="text-[10px] font-mono tracking-wider uppercase px-2 py-1 rounded border border-white/10 text-white/70">
                        {t}
                      </span>
                    ))}
                  </div>

                  <Link
                    to={`/programs#${card.id}`}
                    data-testid={`${HOME.expertiseReadMore}-${card.id}`}
                    className="mt-7 inline-flex items-center gap-2 text-brand-cyan text-sm font-semibold group/btn"
                  >
                    Read more
                    <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
                  </Link>
                </div>
              </motion.div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise;
